import { type LoaderFunctionArgs, redirect } from '@remix-run/node'
import { Outlet } from '@remix-run/react'
import { HighlightedCarsCalculator } from '#app/entities/car/carStatsTracker.ts'
import { getUserId } from '#app/features/auth/auth.server.js'
import MainLayout from '#app/shared/ui/layout/MainLayout.js'

export async function loader({ request }: LoaderFunctionArgs) {
  const userId = await getUserId(request)

  HighlightedCarsCalculator.getInstance()

  if (userId) {
    throw redirect('/admin')
  }

  return { userId }
}

export default function Index() {
  return (
    <MainLayout className="font-saira">
      <Outlet />
    </MainLayout>
  )
}
